var _defs, _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFace(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 93.68 98.57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1e3e80;}.cls-2{fill:#59ac31;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34,91.83c-.14,0-.29-.02-.43-.06-1.71-.5-3.41-1.11-5.05-1.81C9.98,82.09-1.42,63.29,.14,43.2,2.15,17.45,24.73-1.85,50.47,.14c25.75,2.01,45.06,24.58,43.06,50.33-.91,11.69-6.12,22.54-14.68,30.55-.61,.57-1.56,.54-2.13-.07-.57-.61-.54-1.56,.07-2.13,8-7.49,12.88-17.64,13.73-28.58,1.88-24.09-16.2-45.21-40.28-47.09C26.16,1.29,5.03,19.35,3.15,43.43c-1.46,18.8,9.21,36.38,26.55,43.74,1.53,.65,3.12,1.22,4.72,1.69,.8,.24,1.26,1.08,1.02,1.88-.19,.66-.8,1.08-1.45,1.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.06,98.12s-.08,0-.12,0c-1.33-.07-2.36-1.2-2.29-2.54,.68-13.39-1.02-22.04-5.21-26.45-4.37-4.6-11.48-4.62-19.71-4.62h-.08l-.09-2.42v-2.42h.09c9.05,0,17.5,.02,23.3,6.12,5.22,5.49,7.3,15.03,6.54,30.02-.07,1.29-1.13,2.29-2.41,2.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M71.31,48.43c-.38,0-.76-.14-1.05-.43l-13.41-13.04c-.6-.58-.61-1.54-.03-2.13,.58-.6,1.54-.61,2.14-.03l13.41,13.04c.6,.58,.61,1.54,.03,2.13-.3,.3-.69,.46-1.08,.46Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.5,56.53c-.45,0-.9-.16-1.25-.5l-8.69-8.23c-.73-.69-.76-1.84-.07-2.56,.69-.72,1.83-.76,2.56-.07l8.69,8.23c.73,.69,.76,1.84,.07,2.56-.36,.37-.84,.56-1.32,.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.66,37.68h-13.27c-.83,0-1.51-.68-1.51-1.51s.68-1.51,1.51-1.51h13.27c.83,0,1.51,.68,1.51,1.51s-.68,1.51-1.51,1.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.69,50.69c-.72,0-1.3-.58-1.3-1.3V21c0-.72,.58-1.3,1.3-1.3s1.3,.58,1.3,1.3v28.39c0,.72-.58,1.3-1.3,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.07,46.54c0,2.24-1.81,4.05-4.05,4.05s-4.05-1.81-4.05-4.05,1.81-4.05,4.05-4.05,4.05,1.81,4.05,4.05"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.15,98.57h0c-.56,0-1.1-.22-1.5-.62l-10.59-10.59c-.83-.83-.83-2.16,0-2.99,.83-.82,2.16-.82,2.99,0l9.09,9.09,9.09-9.09c.83-.82,2.16-.82,2.99,0,.83,.83,.83,2.16,0,2.99l-10.59,10.59c-.4,.4-.93,.62-1.5,.62Z"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFace);
export default __webpack_public_path__ + "static/media/Face.182267a5aa6231a3e231e0e981ee80bc.svg";
export { ForwardRef as ReactComponent };